<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		</div>
		<div id="content" class="content" ref="content">
			<Loading :is-loading="isListLoading"></Loading>

			<!-- 图文详情 -->
			<section class="section" v-if="!isVideoDetail">
				<div class="ar-content">
					<div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:bold;text-align: center;" v-html="relatedDetail.title"></div>
					<div style="font-family: 黑体, SimHei; font-size: 14px;color:#9b9b9b;margin:12px 0;">
						<span>{{relatedDetail.created_at}}</span>
						<span style="margin-left:20px;">{{$t('contentViews')}} {{views}}</span>
					</div>					
					<div class="html-content" style="margin-top: 20px;" id="html-content" v-html="relatedDetail.content"></div>					
				</div>
			</section>

			<!-- 视频详情（复用青岛发布视频布局） -->
			<div class="detail-container" v-else>
				<div class="outer">
					<div class="cats"></div>
					<div class="a1">
						<div class="detail-left">
							<div class="img-outer" v-if="relatedDetail.direction!=3">
								<video controls autoplay
									:poster="relatedDetail.thumb"
									:alt="relatedDetail.title"
									muted=""
									style="object-fit:cover;width:100%;height:100%;"
									controlslist="nodownload"
									:src="relatedDetail.video"
									oncontextmenu="return false"
									ref="detailVideo">
								</video>
							</div>
							<div class="img-outer-vertical" v-if="relatedDetail.direction==3">
								<video controls autoplay
									:poster="relatedDetail.thumb"
									:alt="relatedDetail.title"
									muted=""
									style="object-fit:contain;width:102%;height:102%;"
									controlslist="nodownload"
									:src="relatedDetail.video"
									oncontextmenu="return false"
									ref="detailVideo">
								</video>
							</div>
						</div>
						<div class="detail-right">
							<div class="b4">
								<div class="pic-detail">
									<div class="detail-item">
										<span class="title">{{$t('video.text1')}}</span><span class="item-content">{{relatedDetail.id}}</span>
									</div>
									<div class="detail-item" v-if="relatedDetail.title">
										<span class="title">{{$t('video.text2')}}</span><span class="item-content" v-html="relatedDetail.title"></span>
									</div>
									<div class="detail-item" v-if="relatedDetail.extension">
										<span class="title">{{$t('video.text3')}}</span><span class="item-content">{{relatedDetail.extension}}</span>
									</div>
									<div class="detail-item" v-if="relatedDetail.duration">
										<span class="title">{{$t('video.text4')}}</span><span class="item-content">{{relatedDetail.duration}}</span>
									</div>
									<div class="detail-item" v-if="relatedDetail.size">
										<span class="title">{{$t('video.text5')}}</span><span class="item-content">{{relatedDetail.size}}MB</span>
									</div>
									<div class="detail-item" v-if="relatedDetail.content">
										<span class="title">{{$t('video.desc')}}</span><span class="item-content" v-html="relatedDetail.content"></span>
									</div>
									<div class="detail-item">
										<span class="title">{{$t('contentViews')}}</span><span class="item-content">{{views}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>		
		<Footer/>
	</div>
	
</template>

<script>
	import related_news_detail from './related_news_detail_controller';
	export default related_news_detail;
</script>

<style src="@/assets/css/related_news_detail.css" scoped></style>
<style src="@/assets/css/publish_video.css" scoped></style>
<style>
</style>
